import imgP from "../../resources/images/profiles/hq/정운기회장님3-removebg.png";
import imgLee from "../../resources/images/profiles/busan/이성욱.png";
import imgPark from "../../resources/images/profiles/hq/박찬욱님-removebg.png";
import imgHwang from "../../resources/images/profiles/hq/황재호님-removebg.png";
import imgYoo from "../../resources/images/profiles/유길석-removebg.png";
import imgSong from "../../resources/images/profiles/other/송창석.png";
const boardmembers = [
  {
    name: "정운기",
    rank: "P",
    engTitle: "President",
    history: [
      {
        div: "現",
        content: "관세동우회 회장",
      },
      {
        div: "現",
        content: "AEO 진흥협회 부회장",
      },
      {
        div: "前",
        content: "한국관세사회 회장(2007-2009)",
      },
      {
        div: "前",
        content: "관세행정발전 심의위원(관세청)",
      },
      {
        div: "前",
        content: "한국관세무역개발원 원장",
      },
      {
        div: "前",
        content: "인천공항세관 세관장",
      },
      {
        div: "前",
        content: "주미 한국대사관 관세참사관",
      },
      {
        div: "前",
        content: "관세중앙분석소장",
      },
    ],
    image: imgP,
  },
  {
    name: "황재호",
    rank: "VP",
    engTitle: "Representative",
    history: [
      {
        div: "現",
        content: "법무부 국제법무지원단 자문위원",
      },     
      {
        div: "現",
        content: "한국관세사회 사회적책임 위원회 위원",
      },          
      {
        div: "現",
        content: "중국 옌타이 보세항구 자문위원",
      },
      {
        div: "前",
        content: "한국관세사회 제도발전위원회 위원",
      },
      {
        div: "前",
        content: "중앙행정심판위원회 관세사",
      },
      {
        div: "前",
        content: "한국관세사회 상생협력위원회 위원",
      },
    ],
    image: imgHwang,
  },

  {
    name: "박찬욱",
    rank: "VP",
    engTitle: "Representative",
    history: [
      // 근거: 박찬욱_대표관세사_프로필.docx (2026-10)
      {
        div: "現",
        content: "법무부 국제법무지원단 자문위원",
      },
      {
        div: "現",
        content: "한국관세사회 정보화위원회 부위원장",
      },
      {
        div: "現",
        content: "관세중앙분석소 AI 품목분류 강사",
      },
      {
        div: "現",
        content: "평택세관 외부평가위원",
      },
      {
        div: "現",
        content: "농림축산식품부 유통이력 심의위원",
      },
      {
        div: "現",
        content: "한국관세사회 평택지부 운영위원",
      },
      {
        div: "現",
        content: "관세미래발전연구소 위원",
      },
      {
        div: "前",
        content: "관세청 CRM 자문위원",
      },
      {
        div: "前",
        content: "서울지방중소기업청 자문관세사",
      },
      {
        div: "前",
        content: "벤처기업협회 자문관세사",
      },
      {
        div: "前",
        content: "구로공단 무역·통관 자문위원",
      },
      {
        content: "HS CODE 품목분류 정보 제공 시스템 특허 출원(발명자)",
      },
      {
        content: "서울대학교 과학기술혁신 최고전략과정 수료",
      },
      {
        content: "제17기 관세사자격시험 합격",
      },
    ],
    image: imgPark,
  },

  {
    name: "이성욱",
    rank: "VP",
    engTitle: "Representative",
    history: [
      {
        div: "現",
        content: "농림축산검역본부 자문관세사",
      },
      {
        div: "前",
        content: "부산지방식약청 자문위원",
      },
      {
        content: "부경대 산업대학원 식품공학 수료",
      },
      {
        content: "해양수산부 항만물류 최고위과정 수료",
      },
    ],
    image: imgLee,
  },
  {
    name: "유길석",
    rank: "CFO",
    engTitle: "CFO",
    history: [
      // { div: '現', content: '관세법인 에이원 CFO(전무)' },
      { div: "現", content: "서울세관 발전심의위원" },
      { div: "前", content: "한국관세무역개발원 물류본부장" },
      { div: "前", content: "한국관세무역개발원 상무이사" },
    ],
    image: imgYoo,
  },
];

export default boardmembers;

export const getBoardMemberbyName = (name) => {
  return boardmembers.find((x) => x.name === name);
};
